module.exports = __webpack_public_path__ + "media/country_flags/bh-15d32348.png";